import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';
class ContainerPackingStore extends EventEmitter {
    PageLoadData = ""
    ChosenOrderResponse = ""
    SubmitResponse = ""
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleContainerPackingStore = (action) => {
        switch (action.action.type) {
            case "PageLoadDetails": {
                this.PageLoadData = action.action.response;
                this.emit('PageLoadDetails');
                break;
            }
            case "ChosenOrderResponse": {
                this.ChosenOrderResponse = action.action.response;
                this.emit('OrderResponse');
                break;
            }
            case "SubmitClickResponse": {
                this.SubmitResponse = action.action.response;
                this.emit('SubmitResponse');
                break;
            }
            case "insertFavContainer": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPageContainer');
                break;
            }
            case "delFavContainer": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPageContainer');
                break;
            }
            case "getFavOfContainer": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpageOfContainer');
                break;
            }
        }
    }
}
const objContainerPackingStore = new ContainerPackingStore;
// Dispatcher code
Dispatcher.register(objContainerPackingStore.handleContainerPackingStore.bind(objContainerPackingStore));
export default objContainerPackingStore;